import { render, staticRenderFns } from "./CourseLayout.vue?vue&type=template&id=3f39a9f8&scoped=true&"
import script from "./CourseLayout.vue?vue&type=script&lang=js&"
export * from "./CourseLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f39a9f8",
  null
  
)

export default component.exports